// extracted by mini-css-extract-plugin
export default {"UserValidation":"styles_UserValidation__YblT8","title":"styles_title__LeECE","error":"styles_error__34T68","success":"styles_success__6HESU"};